import { render } from "./ordentrabajoservicioguia.vue?vue&type=template&id=0c12775b&scoped=true"
import script from "./ordentrabajoservicioguia.vue?vue&type=script&lang=js"
export * from "./ordentrabajoservicioguia.vue?vue&type=script&lang=js"

import "./ordentrabajoservicioguia.vue?vue&type=style&index=0&id=0c12775b&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c12775b"]])

export default __exports__